import { DataTable } from "@rumble-it/common-components/components";
import { getActionsForTable } from "@/pages/admin/rules/actions/lib/queries";
import { useEffect, useState } from "react";

export const ActionTable = () => {
  const [actions, setActions] = useState([]);

  const getActions = async () => {
    setActions(await getActionsForTable());
  };

  useEffect(() => {
    getActions();
  }, []);

  return (
    <DataTable
      tableData={{
        columns: [
          { key: "rule", label: "Rule" },
          { key: "ruleActionType", label: "Actie type" },
          { key: "name", label: "Naam" },
          { key: "description", label: "Omschrijving" },
          { key: "data", label: "Data" },
          { key: "priority", label: "Prioriteit" },
          { key: "active", label: "Actief" },
          { key: "delayInSeconds", label: "Vertraging (sec)" },
          { key: "synchronous", label: "Synchroon" },
          {
            key: "show",
            label: "Acties",
            className: "text-right",
          },
        ],
        data: actions,
      }}
    />
  );
};
